import React , { useRef } from 'react';
import {
    Show,
    SimpleShowLayout,
    CardActions,
    ListButton
} from 'react-admin';
//import { Checkmark } from 'react-checkmark'
import { makeStyles } from '@material-ui/core/styles';
import moment from 'moment'
import ReactToPrint from "react-to-print";
import PrintIcon from '@material-ui/icons/Print';
import PrintExam from './PrintExam'

const Print = ({record}) => {
    const componentRef = useRef();
    const classes = useStyles();
    return (
      <div>
            <div ><PrintExam record={record} classes={classes} ref={componentRef} /></div>
            <br />
            <ReactToPrint
            trigger={() => <button className={classes.printButton} > {<PrintIcon />} </button>}
            content={() => componentRef.current}
            />
      </div>
    );
};

const useStyles = makeStyles({
    root: {  
        display: 'inline-block', 
        marginTop: '3em', 
        zIndex: 2,
        width: "775px",
        maxWidth: '800',            
        alignItems: 'middle',
        margin: "20px 10px 2px 20px",  
    },
    title :{
        display: 'inline-block', 
        margin: '0px 20px 5px -10px', 
        zIndex: 2,
        width: '100%',
        maxWidth: '800px',
        alignItems: 'middle',
        border: '1px solid gray',
        borderRadius: '20px',
        textAlign: 'center'
    },
    p: {
        fontSize: '12px',
    },
    p2: {
        fontSize: '9px',
        textAlign: 'right'
    },
})

const cardActionStyle = {
    zIndex: 2,
    display: 'inline-block',
    float: 'right',
  };

var questions = [];
var answers=[]

const ExamActions = ({basePath, ...props}) => (

    <CardActions style={cardActionStyle}>
        <ListButton basePath={basePath} label="History List" />
    </CardActions>
  );
  

const ExamhistoryShow = ({...props }) => (
    <Show  
       
        actions={<ExamActions />}
        {...props}
    >
        <SimpleShowLayout >  
            <Print  />
        </SimpleShowLayout >     
    </Show>
)

export default ExamhistoryShow;